export const environment = {
  production: true,
  buildId: '3570110626822561',
  configFile: 'config.json',
};
